import type { MatchedColumn } from "@/profitability/types";

export const matchedColumnLabel = (match: MatchedColumn) =>
  match.column
    ? `${match.column} on the ${match.sheet} sheet, read from “${match.read_from}”`
    : `The ${match.sheet} sheet, read from “${match.sheet_read_from}”`;
